import { States } from "@core/enums/state.enum";
import { Status } from "@core/enums/tktStatus";
import { Expose } from "class-transformer";
import { BusLookup } from "@core/model/bus-lookup/bus-lookup";
import { User } from "@generated/queries";
import { CreateTicketStatusChangeInput, UpdateTicketStatusChangeInput } from "@generated/queries";

export class TicketsStatusChange {
    @Expose() id: string | undefined;
    @Expose() ticketId: string | undefined;
    @Expose() latitude: string | undefined;
    @Expose() longitude: string | undefined;
    @Expose() changeStatusId: string | undefined;
    @Expose() description: string | undefined;
    @Expose() changeOn: Date | undefined;
    @Expose() changeById: string | undefined;
    @Expose() assignedUserId: string | undefined;
    @Expose() state: States | undefined;
    @Expose() statusType: Status | undefined;
    @Expose() statusLookup: BusLookup | undefined;
    @Expose() changedUser: User | undefined;
    @Expose() assignedUser: User | undefined;
  }

  export class CreateTicketStatusChange implements CreateTicketStatusChangeInput{
    @Expose() id: string | undefined;
    @Expose() ticketId: string | undefined;
    @Expose() latitude: string | undefined;
    @Expose() longitude: string | undefined;
    @Expose() changeStatusId: string | undefined;
    @Expose() description: string | undefined;
    @Expose() changeOn: Date | undefined;
    @Expose() changeById: string | undefined;
    @Expose() assignedUserId: string | undefined;
    @Expose() state: States | undefined;
    @Expose() statusType: Status | undefined;

  }

  export class UpdateTicketStatusChange implements UpdateTicketStatusChangeInput {
    @Expose() id: string | undefined;
    @Expose() ticketId: string | undefined;
    @Expose() latitude: string | undefined;
    @Expose() longitude: string | undefined;
    @Expose() changeStatusId: string | undefined;
    @Expose() description: string | undefined;
    @Expose() changeOn: Date | undefined;
    @Expose() changeById: string | undefined;
    @Expose() assignedUserId: string | undefined;
    @Expose() state: States | undefined;
    @Expose() statusType: Status | undefined;

  }

  export class UpdateTicketPrimaryAssignee {
    @Expose() ticketId: string | undefined;
    @Expose() assignedUserId: string | undefined;
    @Expose() changeById: string | undefined;

  }

  export class UpdateTicketStatus {
    @Expose() id: string | undefined;
    @Expose() businessId: string | undefined;
    @Expose() currentChangeStatusId?: string ;

  }


  export class TicketStatusChangePayload{
    @Expose() ticketId:string|undefined;
    @Expose() businessId:string|undefined;
    @Expose() userId:string|undefined;
    @Expose() ticketStatusId:string|undefined;
    @Expose() description:string|undefined;
    @Expose() attachments:File[];
    @Expose() resolutionId:string|undefined;
    @Expose() mentionUserIdList:string[];
    @Expose() reviewerId: string | undefined;
    @Expose() updatedOn: string | undefined;
  }
